import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';

type Props = {
  open: boolean;
  /** Usados só pelos textos padrão de exclusão (quando `title`/`description`/`confirmLabel` não são informados). */
  entityLabel?: string;
  entityName?: string;
  /** Variante opcional (ação não irreversível, ex.: "Remover os webhooks Reedy?"): substitui o título padrão. */
  title?: string;
  /** Variante opcional: substitui o corpo padrão ("Você está prestes a excluir…" e "Esta ação é irreversível."). */
  description?: string;
  /** Variante opcional: substitui o rótulo do botão de confirmação ("Excluir definitivamente"). */
  confirmLabel?: string;
  busy?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

const safeEntityName = (name: string, fallback: string) => {
  const containsNationalIdentifier = /(?:\d{3}\.?\d{3}\.?\d{3}-?\d{2}|\d{2}\.?\d{3}\.?\d{3}\/?\d{4}-?\d{2})/.test(name);
  return containsNationalIdentifier || /\b\S+@\S+\.\S+\b|\b(?:token|bearer|id|uid)\s*[:=#-]?\s*[A-Za-z0-9_-]{3,}/i.test(name)
    ? fallback
    : name;
};

const DestructiveActionDialog: React.FC<Props> = ({
  open,
  entityLabel = '',
  entityName = '',
  title,
  description,
  confirmLabel,
  busy = false,
  onCancel,
  onConfirm,
}) => (
  <Dialog open={open} onClose={busy ? undefined : onCancel} aria-labelledby="delete-confirmation-title">
    <DialogTitle id="delete-confirmation-title">{title ?? `Excluir ${entityLabel}?`}</DialogTitle>
    <DialogContent>
      {description !== undefined ? (
        <Typography>{description}</Typography>
      ) : (
        <>
          <Typography>Você está prestes a excluir {entityLabel}: {safeEntityName(entityName, 'registro selecionado')}.</Typography>
          <Typography sx={{ mt: 1 }}>Esta ação é irreversível.</Typography>
        </>
      )}
    </DialogContent>
    <DialogActions>
      <Button onClick={onCancel} disabled={busy}>Cancelar</Button>
      <Button color="error" variant="contained" onClick={onConfirm} disabled={busy}>{confirmLabel ?? 'Excluir definitivamente'}</Button>
    </DialogActions>
  </Dialog>
);

export default DestructiveActionDialog;
